export enum FleetRoute {
  FLEET_LIST = '/fleet',
  ADD_FLEET = '/fleet/add',
  IMPORT_RESULT = '/fleet/import',
  FLEET_CARD = '/fleet/:uuid',
  EDIT_FLEET = '/fleet/:uuid/edit',
  FLEET_SERVICE = '/fleet/:uuid/service',
}
